<template>
  <div :style="style">
    <!-- Ceo toolbar -->
    <v-app-bar class="horizontal-nav" app color="primary" flat dense>
      <!-- Ikon za levi nav bar -->
      <v-app-bar-nav-icon
        @click.stop="leftDrawer = !leftDrawer"
        v-if="bPoint.smAndDown"
        dark
      ></v-app-bar-nav-icon>
      <v-row align="center">
        <!-- <v-toolbar flat dense color="primary"> -->
        <v-col cols="8"  md="9" class="px-0" v-if="!bPoint.smAndDown">
          <HorizontallNavigation></HorizontallNavigation>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="3">
          <v-row no-gutters align="center" justify="end">
            <v-col cols="4" sm="4" md="4" v-if="tenantArrayExist">
              <SelectTenant :theme="true" class="mb-5 mr-4" />
            </v-col>
            <v-col cols="4" sm="4" md="4">
              <Language :theme="true" class="mb-5" />
            </v-col>

        <!-- Help fab button -->
        <v-fab-transition>
          <v-btn
            depressed
            plain
            icon
            @click="helpHandler"
            class="pl-2"
            :style="bPoint.mobile ? { display: 'none' } : ''"
          >
            <v-avatar class="white" size="24">
              <v-icon color="primary" small>help</v-icon>
            </v-avatar>
          </v-btn>
        </v-fab-transition>
        <!-- // Help fab button -->

            <v-menu offset-y dense>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" class="pl-2">
                  <v-avatar class="white" size="24">
                    <v-icon color="primary" small>person</v-icon>
                  </v-avatar>
                </v-btn>
              </template>

              <v-list class="pa-0 text-caption font-weight-light" dense>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-avatar class="primary" size="48px">
                      <v-icon dark>person</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ userData.Username }}</v-list-item-title>
                    <v-list-item-subtitle v-if="userData && userData.IsAdmin">Administrator</v-list-item-subtitle>
                     <v-list-item-title>{{ userData.Tenant }} </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-divider></v-divider>

                <v-list-item key="changePassword" @click="changePasswordModalShow">
                  <v-list-item-action>
                    <v-icon color="primary">build</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ links.changePassword }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item key="logout" @click="logout">
                  <v-list-item-action>
                    <v-icon color="primary">lock_open</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ links.logout }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </v-col>
        <!-- </v-toolbar> -->
      </v-row>
    </v-app-bar>
    <!-- // Ceo toolbar -->

    <!-- Levi menu -->
    <v-navigation-drawer
      v-if="leftDrawer"
      v-model="leftDrawer"
      app
      clipped
      color="primary"
      width="180"
      height="auto"
      class="vertical-nav"
    >
      <v-row justify="center">
        <v-app-bar-nav-icon
          @click.stop="leftDrawer = !leftDrawer"
          v-if="bPoint.smAndDown"
          dark
        ></v-app-bar-nav-icon>
      </v-row>
      <VerticalNavigation v-if="bPoint.smAndDown"></VerticalNavigation>
    </v-navigation-drawer>
    <!-- // Levi menu -->

    <v-main>
      <router-view :key="$route.path"></router-view>
    </v-main>

    <v-dialog
      v-model="notificationDialog.showDialog"
      persistent
      max-width="400px"
      :retain-focus="false"
    >
      <base-dialog-confirmation
        @close="closeDialog"
      >
        <h3>{{ notificationDialog.notificationObject.name }}</h3>
        <p v-html="notificationDialog.notificationObject.description"></p>
        <p>{{ notificationCreatedAt + formatDate(notificationDialog.notificationObject.createdAt) }}</p>
      </base-dialog-confirmation>
    </v-dialog>

    <ChangePasswordComponent :dialog="changePasswordDialog" @close="closeChangePasswordModal"></ChangePAsswordComponent>

    <!-- strange fix for v-textarea size and resizer position accross all pages  -->
    <v-textarea v-show="false"></v-textarea>

  </div>
</template>

<script>
import store from '@/store/store'
import Language from '@/components/language/Language'
import SelectTenant from '@/components/SelectTenant'
import BaseDialogConfirmation from '@/components/BaseDialogConfirmation'
import ThemePicker from '@/components/theme/ThemePicker'
import translate from '@/utils/genTable/multilanguageHelper.js'
import EventBus from '../event-bus'
import HorizontallNavigation from '@/components/HorizontallNavigation'
import VerticalNavigation from '@/components/VerticalNavigation'
import help from '@/resource/help.json'
import httpClient from '../api/httpClient'
import '../assets/custom.css'
import Vue from 'vue'
import ChangePasswordComponent from '../components/v2/ChangePasswordComponent'
import colorsMixin from '../components/v2/colorsMixin'
import formatDate from '@/utils/formatDateHelper.js'

export default {
  name: 'BaseLayout',
  components: {
    Language,
    SelectTenant,
    ThemePicker,
    HorizontallNavigation,
    VerticalNavigation,
    BaseDialogConfirmation,
    ChangePasswordComponent
  },
  data() {
    return {
      leftDrawer: false,
      appName: 'APP NAME',
      drawer: true,
      fixed: false,
      miniVariant: false,
      searching: false,
      right: true,
      rightDrawer: false,
      notificationDialog: {
        showDialog: false,
        notificationObjects: [],
        notificationObject: {}
      },
      userData: JSON.parse(store.getters['user/jwtData'].UserData),
      links: {
        logout: translate('Logout', 'baseLayout'),
        homePage: translate('Home page', 'baseLayout'),
        changePassword: translate('Change password', 'baseLayout')
      },
      changePasswordDialog: {
        show: false
      },
      changePasswordSnackbar: true,
      notificationCreatedAt: translate('Notification date: ', 'baseLayout')
    }
  },
  mounted() {
    EventBus.$on('COLLAPSE_LEFT_NAVIGATION', this.collapseLeftNavigation)
    document.querySelector('.v-application--wrap').style =
      'background: white !important;' + this.mapStyle
    this.searchForNotifications()
    var locale = this.$i18n.locale.split('-')[0]
    Vue.prototype.locale = locale
    this.refreshColors()
  },
  methods: {
    logout() {
      store
        .dispatch('user/logout')
        .then(() => {
          this.$router.push('/login', () => {
            store.dispatch(
              'notification/add',
              {
                type: 'success',
                message: 'Successfully logged out.'
              },
              { root: true }
            )
          })
        })
        .then(() => {
          store.dispatch('user/clearTenants')
        })
      localStorage.removeItem('tenants')
    },
    closeDialog() {
      this.notificationDialog.showDialog = false
      if (
        !(this.notificationDialog.notificationObject.actualIndex ==
        this.notificationDialog.notificationObjects.length - 1)
      ) {
        this.setupNexNotification()
      }
    },
    confirmNotification() {
      httpClient.put(
        'notifications/confirmnotification/' +
          this.notificationDialog.notificationObject.id
      )
    },
    searchForNotifications() {
      httpClient.get('notifications/getnotification').then(response => {
        if (response.data.length > 0) {
          this.notificationDialog.showDialog = true
          this.notificationDialog.notificationObjects = response.data
          this.notificationDialog.notificationObject = response.data[0]
          this.notificationDialog.notificationObject.actualIndex = 0
        }
      })
    },
    setupNexNotification() {
      if (
        !(this.notificationDialog.notificationObject.actualIndex ==
        this.notificationDialog.notificationObjects.length - 1)
      ) {
        let actualIndex =
          this.notificationDialog.notificationObject.actualIndex + 1
        if (this.notificationDialog.notificationObjects.length >= actualIndex) {
          this.notificationDialog.notificationObject = this.notificationDialog.notificationObjects[
            actualIndex
          ]
          this.notificationDialog.notificationObject.actualIndex = actualIndex
          this.notificationDialog.showDialog = true
        }
      } else this.notificationDialog.showDialog = false
    },
    collapseLeftNavigation() {
      this.miniVariant = true
    },
    helpHandler() {
      const mainHelpPage = 'https://help.fleetmanager.rs'
      if (help.hasOwnProperty(this.helpObject['key'])) {
        window.open(`${mainHelpPage}/${this.helpObject['value']}`, '_blank')
      } else {
        window.open(mainHelpPage, '_blank')
      }
    },
    changePasswordModalShow() {
      this.changePasswordDialog.show = true
    },
    closeChangePasswordModal() {
      this.changePasswordDialog.show = false
    },
    formatDate(value) {
      if (!value) {
        return
      }
      return formatDate(value, 'long', true)
    }
  },
  computed: {
    style() {
      return {
        '--primary-color': this.primaryColor,
        '--secondary-color': this.secondaryColor,
        '--navigation-gradient-color': this.navigationGradientColor,
        '--navigation-gradient-second-color': this.navigationGradientSecondColor
      }
    },
    bPoint() {
      return this.$vuetify.breakpoint
    },
    helpObject() {
      const obj = {}
      let key = ''
      let value = ''
      const arr = this.$route.path
        .substring(1)
        .replace('/', '.')
        .split('.')
      if (arr.length > 1) {
        key = arr[arr.length - 1]
      } else {
        key = arr[0]
      }
      value = help[key]
      this.$set(obj, 'key', key)
      this.$set(obj, 'value', value)
      return obj
    },
    tenantArrayExist() {
      return localStorage.tenants !== 'undefined'
    },
    mapStyle(){
      return document.body.clientWidth < 800 ? " max-width: 93%; width: 93%; margin: 0 auto;" : ""
    }
  },
  mixins: [colorsMixin]
}
</script>

<style>
.local-table
  > .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th {
  background-color: var(--primary-color);
  color: white;
}
.horizontal-nav {
  background: linear-gradient(
    to left,
    var(--navigation-gradient-color) 50%,
    var(--navigation-gradient-second-color) 100%
  );
}

.vertical-nav {
  z-index: 11 !important;
}
</style>
